/// <amd-module name="Repos/Editor/Components/FileViewer" />
import * as React from "react";
import { IFileViewerProps } from "Repos/Common/Contracts/Editor";
import { ErrorBoundary } from "VSS/Platform/Components/ErrorBoundary";
import { Components, css } from "VSS/Platform/Layout";
import { AnnotatedCodeEditor } from "./AnnotatedCodeEditor";
import { BinaryViewer } from "./BinaryViewer";
import { CodeEditor } from "./CodeEditor";
import { ImageViewer } from "./ImageViewer";

export const FileViewer = (props: IFileViewerProps) => {
    let content: JSX.Element | null = null;
    let wrapperClassName: string | undefined;
    if (props.content.metadata.isBinary) {
        wrapperClassName = "";
        if (props.content.metadata.isImage && props.getDownloadUrl) {
            content = <ImageViewer content={props.content} onLoaded={props.onLoaded} url={props.getDownloadUrl(false)} />;
        } else {
            content = (
                <BinaryViewer
                    content={props.content}
                    onLoaded={props.onLoaded}
                    getDownloadUrl={props.getDownloadUrl ? () => props.getDownloadUrl!(true) : undefined}
                />
            );
        }
    } else if (props.annotationBlocks) {
        wrapperClassName = props.editorClassName;
        content = (
            <AnnotatedCodeEditor
                annotationBlocks={props.annotationBlocks}
                content={props.content}
                editable={props.editable}
                initialScrollPosition={props.initialScrollPosition}
                onLoaded={props.onLoaded}
                onScrollChanged={props.onScrollChanged}
                scrollToLine={props.scrollToLine}
                showMarginForIcons={props.showMarginForIcons}
            />
        );
    } else {
        wrapperClassName = props.editorClassName;
        content = (
            <CodeEditor
                content={props.content}
                editable={props.editable}
                editorWidgets={props.editorWidgets}
                initialScrollPosition={props.initialScrollPosition}
                onContentChanged={props.onContentChanged}
                onLoaded={props.onLoaded}
                onScrollChanged={props.onScrollChanged}
                getCodeSelectionLinkUrl={props.getCodeSelectionLinkUrl}
                getDownloadUrl={props.getDownloadUrl}
                initialSelectedText={props.initialSelectedText}
                scrollToLine={props.scrollToLine}
                showMarginForIcons={props.showMarginForIcons}
            />
        );
    }

    return (
        <ErrorBoundary handlerComponentType="tfs.page-error-handler">
            <div className={css(props.className, wrapperClassName)}>{content}</div>
        </ErrorBoundary>
    );
};

Components.add("repos-file-viewer", FileViewer);
